import {
  AccountingTypeModel,
  BudgetTypeModel,
  ExpenditureBudgetPurposeModel,
  budgetType,
} from '@/features/master-table/models';
import { z } from 'zod';

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

export const ExpenditureItemBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  priorId: z.string().uuid().nullable(),
  expenditureCartId: z.string().uuid(),
  expenditureBudgetPurposeId: z.string().uuid().nullable(),
  expenditureBudgetPurposeDescription: z.string().nullish(),
  budgetTypeId: z.string().uuid(),
  requestedAmount: z.number().nullish(),
  finalizedAmount: z.number().nullish(),
  remark: z.string().nullish(),
});

export const ExpenditureItemsModel = ExpenditureItemBaseModel.extend({
  expenditureBudgetPurpose: ExpenditureBudgetPurposeModel.nullable(),
  budgetType: BudgetTypeModel,
}).array();

export const ExpenditureItemModel = ExpenditureItemBaseModel.extend({
  expenditureBudgetPurpose: ExpenditureBudgetPurposeModel.nullable(),
  budgetType: BudgetTypeModel,
});

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

const ExpenditureItemFormBaseSchema = ExpenditureItemBaseModel.pick({
  budgetTypeId: true,
  expenditureBudgetPurposeDescription: true,
  remark: true,
  requestedAmount: true,
  finalizedAmount: true,
}).extend({
  expenditureBudgetPurposeConstituentIds: z.string().uuid().array().nullish(),
});

export const ExpenditureItemFormSchema = ExpenditureItemFormBaseSchema.extend({
  budgetType,
});

export const CreateExpenditureItemParamSchema =
  ExpenditureItemFormBaseSchema.extend({
    projectId: z.string().uuid(),
    subProjectId: z.string().uuid(),
    expenditureCartId: z.string().uuid(),
    budgetTypeId: z.string().uuid(),
    accountingType: AccountingTypeModel.shape.type,
  });

export const UpsertPriorReserveBudgetItemFormSchema =
  ExpenditureItemFormBaseSchema.pick({
    remark: true,
  }).extend({
    finalizedAmount: z.number(),
    expenditureCartId: ExpenditureItemBaseModel.shape.expenditureCartId,
    budgetTypeId: ExpenditureItemBaseModel.shape.budgetTypeId,
  });

export const PriorReserveBudgetItemMutationParamsSchema =
  UpsertPriorReserveBudgetItemFormSchema.extend({
    projectId: z.string().uuid(),
    subProjectId: z.string().uuid(),
  });
